define ['./privacy.scss'], () ->
  ($scope, $state, RentappService) ->



// WEBPACK FOOTER //
// ./components/home/privacy/privacy.coffee